import { defaultConfig } from './config';
import { fileGenerator } from './fileCanaryGenerator';

export const File = fileGenerator(defaultConfig);
